import {PageLayout, Placeholder as BasePlaceholder} from '~/components'

export const Placeholder = ({name}) => {
	return (
		<PageLayout
			name={name}
			bodyLayoutProps={{
				width: 1600,
				padding: 24,
				grow: true,
				horizontal: 'center',
				vertical: 'center',
			}}
		>
			<BasePlaceholder animation="bar-chart" name={name} />
		</PageLayout>
	)
}
